<div
  class="l-header_content"
  [ngClass]="{ 'l-header--mobileOpenned': mobileMenuOpen }"
>
  <!-- Icone Mobile  -->
  <button
    class="l-header_btnMenu d-flex l-grid--middle"
    (click)="openCloseMenu()"
    mat-icon-button
    [matMenuTriggerFor]="userMenuMobile"
    type="button"
    [title]="mobileMenuOpen ? 'Fechar menu mobile' : 'Abrir menu mobile'"
    *ngIf="mobile"
  >
    <svg class="l-header_btnMenu_icon c-icon">
      <use
        [attr.xlink:href]="mobileMenuOpen ? '#ic-close' : '#ic-burgerMenu'"
      />
    </svg>
  </button>

  <div class="l-header_logoBox" [routerLink]="['/']">
    <svg class="l-header_icon c-icon">
      <use
        [attr.xlink:href]="
          mobileIcon || resizeMenu ? '#ic-logoTxt' : '#ic-logo'
        "
      />
    </svg>
  </div>

  <app-menu-desktop
    class="l-header_menuDesktop"
    *ngIf="!mobile"
  ></app-menu-desktop>

  <app-user-actions
    class="l-header_userActionsBox"
    *ngIf="!mobileMenuOpen"
  ></app-user-actions>
</div>

<mat-menu
  class="c-header_menuUserMobile"
  (closed)="openCloseMenu()"
  xPosition="before"
  #userMenuMobile="matMenu"
>
  <div class="c-header_content">
    <a
      class="c-header_box"
      (click)="onMobileMenuClick(menu)"
      routerLinkActive="c-menu--active"
      [routerLinkActiveOptions]="{ exact: true }"
      *ngFor="let menu of menuList"
      [routerLink]="menu.link"
    >
      <svg class="c-header_box_icon c-icon">
        <use [attr.xlink:href]="menu.icon" />
      </svg>
      <p class="c-header_box_text">{{ menu.title }}</p>
    </a>
  </div>
</mat-menu>
